/*
	Поддерживает возможность использования внешней кнопки - она находятся
	вне формы и работает с той формой, которая сейчас активна. Блок для
	вывода ошибки внутренний, должен быть свой у каждой формы.

	Поддерживается два типа переключателей:

		1. Форм - переключает вложенные формы.
		2. Групп - переключает группы форм.
*/

class FormGroup {
	$group;
	$forms;
	$togglers;
	$radioTogglers;
	$button;
	forms;
	activeForm;
	lastForm;
	onSuccess;

	constructor($group, forms, options = {}) {
		forms = forms || false;

		var
			$firstGroup;

		this.$group = $group;
		this.$forms = $group.find('.js-form');
		this.$togglers = $group.find('.js-form-group-toggler');
		this.$radioTogglers = $group.find('.js-form-group-radio-toggler');
		this.$button = $group.find('button:not(form button)');
		this.lastForm = false;
		this.activeForm = false;

		this.onSuccess = options.onSuccess || null;

		$firstGroup = this.$radioTogglers.first();
		$firstGroup.addClass('active');

		if (forms) {
			this.forms = {};

			forms.forEach(form => {
				if (form.$form.is(':first-of-type')) {
					form.$form.show();

					if (!this.activeForm)
						this.activeForm = form.$form.attr('id');
				}

				else form.$form.hide();

				if (this.onSuccess)
					form.onSuccess = this.onSuccess;

				this.forms[form.$form.attr('id')] = form;
			});
		}

		if (this.$radioTogglers.length) {
			this.$radioTogglers.each(function() {
				$(this)
					.next('label')
					.prepend('<span class="form-group-blocker">')
				;
			});
		}

		this.$togglers.on('click', this.togglerClick.bind(this));
		this.$radioTogglers.on('click', this.radioTogglerClick.bind(this));
		this.$button.on('click', this.buttonClick.bind(this));
		this.$forms.on('formButtonActive', this.buttonActive.bind(this));
	}

	//-------------------------------------------------
	//Изменить активность кнопки
	activeButton() {
		if (this.$button.length)
			this.$button.attr('disabled', !this.forms[this.activeForm].buttonActive);
	}

	//-------------------------------------------------
	//Изменить активность форм
	activeForms(flag = true) {
		Object.values(this.forms).forEach($form => {
			$form.active(flag);
		});

		this.$togglers.toggleClass('disabled', !flag);
	}

	//-------------------------------------------------
	//Событие нажатия на переключатель
	togglerClick(event) {
		var
			$toggler = $(event.currentTarget),
			formId = $toggler.attr('data-form');

		this.$togglers.removeClass('active');
		
		$toggler.addClass('active');

		this.forms[this.activeForm].$form.hide();
			
		this.$forms.filter(formId).show();

		this.activeForm = formId.replace('#', '');
		this.activeButton();

		// Уведомить форму об активации
		if (this.forms[this.activeForm].onActivate)
			this.forms[this.activeForm].onActivate();
	}

	//-------------------------------------------------
	//Событие нажатия на radio-переключатель
	radioTogglerClick(event) {
		var
			self = this,
			$toggler = $(event.currentTarget),
			$container = self.$group.find(`[for="${$toggler.attr('id')}"]`),
			lastForm = self.activeForm,
			$form;

		if ($toggler.hasClass('active'))
			return false;

		if (self.lastForm) $form = $(`#${self.lastForm}`);
		else $form = $container.find('.js-form').first();

		self.activeForm = $form.attr('id');
		self.lastForm = lastForm;

		self.$radioTogglers.removeClass('active');
		$toggler.addClass('active');
		$form.find('input:not([type="hidden"])').first().focus();

		self.activeButton();
	}

	//-------------------------------------------------
	//Событие нажатия на внешнюю кнопку
	buttonClick(event) {
		this.forms[this.activeForm].$form.submit();
	}

	//-------------------------------------------------
	//Событие смены активности кнопки
	buttonActive(event, active) {
		this.$button.attr('disabled', !active);
	}
}